/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Button, Table, Spin, Icon, Card, message, Switch, Modal } from 'antd';
import './index.less';
import { errorHandle, navigation } from '@comall-backend-builder/core/lib/services';
import { Image } from '@comall-backend-builder/components-basis';
import { services } from '@comall-backend-builder/core';
import moment from 'moment';
const { confirm } = Modal;

export const SidebarMenuView: React.FC<any> = () => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadSknList();
    }, []);

    const loadSknList = () => {
        setLoading(true);

        services.api
            .get({}, { apiPath: ` /appletTab` })
            .then((res: any) => {
                const result = res.list || [];
                setTableData(result);
                setLoading(false);
            })
            .catch((e: any) => {
                errorHandle(e);
                setLoading(false);
            });
    };

    const handleMoveUp = (record: any, index: number) => {
        if (index === 0 || index === 1) {
            message.warning('无法向上！');
            return;
        }
        const needFallItem = tableData[index - 1];
        const params = {
            riseId: record.id,
            riseSort: needFallItem.sort,
            fallId: needFallItem.id,
            fallSort: record.sort,
        };
        setLoading(true);
        services.api
            .put(params, { apiPath: `/appletTab/update_tab_sort` })
            .then(() => {
                message.success('排序成功');
                loadSknList();
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleMoveDown = (record: any, index: number) => {
        if (index === tableData.length - 1) {
            message.warning('无法向下！');
            return;
        }
        const needFallItem = tableData[index + 1];
        const params = {
            riseId: record.id,
            riseSort: needFallItem.sort,
            fallId: needFallItem.id,
            fallSort: record.sort,
        };
        setLoading(true);
        services.api
            .put(params, { apiPath: `/appletTab/update_tab_sort` })
            .then(() => {
                message.success('排序成功');
                loadSknList();
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // 切换是否展示文字
    const handleSwitchChange = (record: any) => {
        setLoading(true);
        const serveParams = {
            ...record,
            isShowCharacters: record?.isShowCharacters === 1 ? 0 : 1,
            fontColor: record.fontColor || '#AD7C72',
        };
        delete serveParams.id;
        services.api
            .put({ ...serveParams }, { apiPath: `/appletTab/${record.id}/updateAppletTab` })
            .then(() => {
                loadSknList();
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 20);
            });
    };

    // 切换图标是否启用
    const handleIsUseImgChange = (record: any) => {
        setLoading(true);
        const serveParams = {
            ...record,
            isUseImg: record?.isUseImg === 1 ? 0 : 1,
            fontColor: record.fontColor || '#AD7C72',
        };

        if (!serveParams.isUseImg) {
            serveParams.isShowCharacters = 0;
        }
        delete serveParams.id;
        services.api
            .put({ ...serveParams }, { apiPath: `/appletTab/${record.id}/updateAppletTab` })
            .then(() => {
                loadSknList();
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 20);
            });
    };

    // 新增tab
    const handleAdd = () => {
        let path = `/design/sidebarMenu/add`;
        navigation.goto(path);
    };

    // 编辑tab
    const handleEdit = (record: { id: any }, index: any) => {
        let path = `/design/sidebarMenu/edit/${record.id}/${index}`;
        navigation.goto(path);
    };

    // 查看
    const handleSee = (record: { id: any }) => {
        let path = `/design/sidebarMenu/detail/${record.id}`;
        navigation.goto(path);
    };

    // 删除tab
    const showDeleteConfirm = (id: any) => {
        confirm({
            title: '确定要删除吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                setLoading(true);
                services.api
                    .delete({}, { apiPath: `/appletTab/${id}` })
                    .then(() => {
                        message.success('删除成功！');
                        loadSknList();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const columns: any[] = [
        {
            title: '编号',
            dataIndex: 'id',
            align: 'center', // 居中对齐
        },
        {
            title: '导航名称',
            dataIndex: 'name',
            align: 'center', // 居中对齐
        },
        {
            title: '页面排序',
            align: 'center', // 居中对齐
            dataIndex: 'action',
            render: (_: any, record: any, index: any) => {
                return (
                    <div>
                        {index > 0 ? (
                            <div>
                                <div className="arrow-icon">
                                    <Icon
                                        type="arrow-up"
                                        onClick={() => handleMoveUp(record, index)}
                                    />
                                </div>
                                <div className="arrow-icon">
                                    <Icon
                                        type="arrow-down"
                                        onClick={() => handleMoveDown(record, index)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                );
            },
        },

        {
            title: '创建时间',
            dataIndex: 'makeDate',
            align: 'center', // 居中对齐
            render: (makeDate: any) => (
                <span>{makeDate ? moment(makeDate).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
            ),
        },
        {
            title: '图标是否启用',
            dataIndex: 'isUseImg',
            align: 'center', // 居中对齐
            render: (isUseImg: any, record: any, index: any) => (
                <Switch checked={isUseImg === 1} onChange={() => handleIsUseImgChange(record)} />
            ),
        },
        {
            title: '是否展示文字',
            dataIndex: 'isShowCharacters',
            align: 'center', // 居中对齐
            render: (isShowCharacters: any, record: any) => (
                <Switch
                    checked={isShowCharacters === 1}
                    onChange={() => handleSwitchChange(record)}
                />
            ),
        },
        {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            render: (_: any, record: any, index: any) => (
                <>
                    <a
                        type="link"
                        onClick={() => {
                            handleSee(record);
                        }}
                    >
                        查看
                    </a>

                    <a
                        style={{ display: 'inline-block', marginLeft: '12px' }}
                        type="link"
                        onClick={() => {
                            handleEdit(record, index);
                        }}
                    >
                        编辑
                    </a>

                    {index > 0 ? (
                        <a
                            style={{ display: 'inline-block', marginLeft: '12px', color: 'red' }}
                            type="link"
                            onClick={() => {
                                showDeleteConfirm(record.id);
                            }}
                        >
                            删除
                        </a>
                    ) : (
                        ''
                    )}
                </>
            ),
        },
    ];

    const ImageProps = {
        text: '品真阁',
        style: {
            width: '35px',
            height: '35px',
        },
    };

    const ImageLiveProps = {
        text: '品真阁',
        style: {
            width: '35px',
        },
    };

    return (
        <>
            <Card title="侧边导航tab">
                <div className="sidebarMenu-box">
                    <div className="left-box">
                        <div className="icon-box">
                            {tableData.map((item, index) => {
                                return (
                                    <div>
                                        {item.isUseImg === 1 ? (
                                            <div key={index} className="icon-item">
                                                {item.linkType === 'live' ||
                                                item.linkType === 'liveItem' ||
                                                item.name === '直播预告' ||
                                                item.name === '直播回放' ? (
                                                    <Image
                                                        className="icon-imageLive"
                                                        imageurl={item.img}
                                                        {...ImageLiveProps}
                                                    />
                                                ) : (
                                                    <Image
                                                        className="icon-image"
                                                        imageurl={item.img}
                                                        {...ImageProps}
                                                    />
                                                )}
                                                {item.isShowCharacters === 1 && item.name ? (
                                                    <div
                                                        className="icon-name"
                                                        style={{ color: item.fontColor }}
                                                    >
                                                        {item.name}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        ) : null}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="right-box">
                        <Button type="primary" style={{ margin: '24px 0' }} onClick={handleAdd}>
                            添加页面导航
                        </Button>
                        <Spin spinning={loading}>
                            <Table
                                pagination={false} // 禁用分页
                                rowKey="sknCode"
                                loading={loading}
                                columns={columns}
                                dataSource={tableData}
                            />
                        </Spin>
                    </div>
                </div>
            </Card>
        </>
    );
};
